import React from "react";
import './AdSpacer.scss'

const AdSpacer = ({customStyle}) => (<div className="ad-spacer" style={customStyle}/>);

export default AdSpacer;